export interface ProgressLegendItem {
    label: string;
    color: string;
    count: number;
}

export interface GroupedProgressLegendProps {
    /** Legend items in display order. */
    items: ProgressLegendItem[];
}

export const GroupedProgressLegend = ({ items }: GroupedProgressLegendProps) => (
    <div className="grouped-progress__legend">
        {items.map((item) => (
            <span key={item.label} className="grouped-progress__legend-item">
                <span
                    className="grouped-progress__legend-dot"
                    style={{ backgroundColor: item.color }}
                />
                {item.label}: {item.count}
            </span>
        ))}
    </div>
);

export default GroupedProgressLegend;
